import React from "react";
import { CheckIcon, InfoIcon, TargetIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { volumes } from "../../data/volumes";
import { MOCKUP_URL } from "../../data/offer";
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-345" data-mp="2t07t3qp5nm4w">
      <div className="mx-auto max-w-4xl" data-id="element-346" data-mp="2szes76cvnquo">
        <SectionHeading eyebrow="Introducing the Autism Communication Support Blueprint™" title="6 Practical Volumes to Organize Your Communication Support Planning From Start to Finish" subtitle="A structured educational collection covering communication foundations, functional observation, visual supports, AAC planning, everyday implementation, and collaborative follow-up." data-id="element-347" data-mp="2o13m96ppe0hq" />
        <p className="mx-auto mt-4 max-w-2xl text-center text-base font-semibold text-ink/70" data-id="element-348" data-mp="2592dncn4mvv4">
          Each volume addresses a different part of the planning process. Together, they provide an organized
          reference you can return to whenever you’re preparing communication support resources.
        </p>

        <div className="mt-10 space-y-6" data-id="element-349" data-mp="37x4dhshrsa4f">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_8px_28px_rgba(14,37,87,0.07)]" data-id="element-350" data-mp="2u5r06wagg8hu">
              <div className="px-5 py-5 sm:px-8" style={{
            backgroundColor: v.tint
          }} data-id="element-351" data-mp="2y72pf0pf2rpi">
                <span className="inline-block rounded-full bg-white px-3.5 py-1 text-sm font-black uppercase tracking-wide" style={{
              color: v.ink
            }} data-id="element-352" data-mp="3lxf8n7q44ave">
                  Volume {v.number}
                </span>
                <h3 className="mt-3 text-balance text-2xl font-black leading-tight text-navy sm:text-3xl" data-id="element-353" data-mp="3hua7b8hrqf8c">{v.title}</h3>
                <p className="mt-2 text-lg font-extrabold leading-snug" style={{
              color: v.ink
            }} data-id="element-354" data-mp="21g0rj2rldyt4">
                  {v.subtitle}
                </p>
              </div>
              <div className="px-5 py-6 sm:px-8" data-id="element-355" data-mp="bz585aquhp2z">
                {v.intro.map(p => <p key={p} className="mb-3 text-base font-semibold leading-relaxed text-ink/80" data-id="element-356" data-mp="c0znm9jckozo">
                    {p}
                  </p>)}
                <p className="mt-5 text-sm font-black uppercase tracking-wide text-navy" data-id="element-357" data-mp="27shgmgs94yj">Inside, you’ll discover:</p>
                <ul className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-358" data-mp="3ub1ryyrrl58k">
                  {v.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-359" data-mp="3pbouzl76ihs9">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{
                  backgroundColor: v.tint,
                  color: v.ink
                }} data-id="element-360" data-mp="3ke6wypup9mz1">
                        <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-361" data-mp="3bgmrt5tpv6j5" />
                      </span>
                      <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-362" data-mp="19n6nx78mbv68">{item}</span>
                    </li>)}
                </ul>
                <div className="mt-6 flex gap-3 rounded-2xl bg-navy p-4" data-id="element-363" data-mp="2rka2644sgava">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-sun" aria-hidden="true" data-id="element-364" data-mp="2wileclik2xgo" />
                  <p className="text-[15px] font-semibold leading-relaxed text-white" data-id="element-365" data-mp="31beh53ugrvq4">
                    <span className="font-black text-sun" data-id="element-366" data-mp="35c6sc2mwcap1">Your takeaway: </span>
                    {v.takeaway}
                  </p>
                </div>
                {v.note && <p className="mt-3 flex gap-2 text-sm font-semibold italic text-ink/60" data-id="element-367" data-mp="2dk90imgp8zer">
                    <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-368" data-mp="2hmm4b5bvyn8w" />
                    {v.note}
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mt-12 rounded-3xl bg-white p-5 text-center shadow-[0_8px_28px_rgba(14,37,87,0.07)] sm:p-8" data-id="element-369" data-mp="3t2asu14sfubt">
          <img src={MOCKUP_URL} alt="All six volumes of the Blueprint collection" className="mx-auto w-full max-w-xl" data-id="element-370" data-mp="1twxh8rlee9y" />
          <h3 className="mt-5 text-balance text-2xl font-black uppercase leading-tight text-navy sm:text-3xl" data-id="element-371" data-mp="eb1fs4vp6wr">
            Six Volumes. One Practical Communication Support Collection.
          </h3>
          <p className="mx-auto mt-3 max-w-2xl text-base font-semibold leading-relaxed text-ink/75" data-id="element-372" data-mp="9g2932izbnt9">
            Instead of disconnected resources, you’ll have a structured educational reference covering the key
            areas of individualized communication support planning.
          </p>
          <div className="mt-7" data-id="element-373" data-mp="edk6bvnmwelf">
            <CtaButton label="Yes! I want all six volumes" sub="Get the Complete Collection for Just $27" data-id="element-374" data-mp="t2qdq6wmlb4e" />
          </div>
        </div>
      </div>
    </section>;
}